import { useQuery } from "react-query";
import { zodParseWithDetailedLog } from "src/api/apiErrorLogs";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { z } from "zod";
import { getConsentHeaders } from "./consentHeaders";

export const getConsentPreferencesKey = "getConsentPreferences" as const;

const ConsentPreferenceSchema = z.object({
    itemId: z.number(),
    versionId: z.number(),
    code: z.string(),
    name: z.string(),
    description: z.string().nullable().optional(),
    category: z.string().nullable().optional(),
    version: z.string(),
    title: z.string(),
    summary: z.string().nullable().optional(),
    content: z.string().nullable().optional(),
    documentUrl: z.string().nullable().optional(),
    enabled: z.boolean(),
    updatedAt: z.string().nullable().optional(),
});

export type ConsentPreference = z.infer<typeof ConsentPreferenceSchema>;

type Options = {
    enabled?: boolean;
};

export const useGetConsentPreferences = (options?: Options) => {
    const { enabled = true } = options ?? {};

    const query = useQuery({
        queryKey: [getConsentPreferencesKey],
        enabled,
        queryFn: async () => {
            const response = await loggedInApiCall.get("/api/users/me/consent-preferences", {
                headers: getConsentHeaders(),
            });

            return response;
        },
        select: (response) => {
            const preferences = response.data["hydra:member"] ?? [];

            return zodParseWithDetailedLog(preferences, ConsentPreferenceSchema.array(), {
                operation: "GET",
                endpoint: "/users/me/consent-preferences",
            });
        },
    });

    return {
        consentPreferences: query.data,
        ...query,
    };
};
